import React from 'react';
import { Container, Typography } from '@mui/material';
import CardsEventos from '../../components/EventosComponents/CardsEventos';
import './Eventos.css'

export default function Eventos() {
  return (
    <div>
      <div className="TituloEventos">
       
         
               <Typography
             variant="h1"
             align="center"
             gutterBottom
             style={{
               fontFamily: "'Lato', serif",
               color: "white",
               borderBottom: "4px solid #d4af37",
               paddingBottom: "10px",
               textTransform: "uppercase",
               animation: "glow 2s infinite alternate",
               marginTop: "7%"  // Aqui é onde você define o espaço superior
             }}
           > 
  O ensino da fé cristã na Península Ibérica.
</Typography>

         
      </div>
      
         <CardsEventos />
     

       
    </div>
  );
}
